<template>
  <div style="padding: 0.25rem 0">
    <div class="flex-items">
      <div class="tui-pillar"></div>
      <div class="tui-headerTitle">{{ Title }}</div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    Title: {
      type: String,
      default: "",
    },
  },
};
</script>
<style lang="less" scoped>
.tui-pillar {
  width: 0.075rem;
  height: 0.3rem;
  background: #27abf7;
  border-radius: 3px;
}
.tui-headerTitle {
  font-size: 0.3rem;
  color: #333;
  font-weight: 600;
  padding-left: 0.125rem;
}
</style>